<template>
    <v-expansion-panel v-model="panelIndex" class="notasPanel" >
        <v-expansion-panel-content class="secondary textwhite">
            <template v-slot:header>
                <div class="white--text">Filtros</div>
            </template>
            <v-layout style="background-color: white; ">
                <v-form v-model="valid" class="fullwidth">
                    <v-container grid-list-md text-xs-center pa-0>
                        <v-layout row wrap>   
                            <v-btn color="primary" @click.stop="mailclick()" class="email347btn" ripple v-if="!send347 && $store.state.usuario.type == 'Cliente'">
                                Solicitar 347
                            </v-btn>     
                            <v-flex xs3 >
                                <v-select
                                v-if="send347 && $store.state.usuario.type == 'Cliente'"
                                v-model="year"
                                :items="years"
                                label="Año"
                                ></v-select>                     
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field @click.stop="" v-if="send347 && $store.state.usuario.type == 'Cliente'" v-model="$store.state.usuario.lastEmail" label="Email" type="text"></v-text-field>                                            
                            </v-flex>
                            <v-flex xs2>
                                <v-btn @click.stop="sendclick()" class="email347btn" icon ripple v-if="send347 && $store.state.usuario.type == 'Cliente'">
                                    <v-icon color="grey lighten-1">send</v-icon>
                                </v-btn>       
                                <v-btn @click.stop="mailclick()" class="email347btn" icon ripple v-if="send347 && $store.state.usuario.type == 'Cliente'">
                                    <v-icon color="grey lighten-1">cancel</v-icon>
                                </v-btn>   
                            </v-flex>  
                        </v-layout>      
                        <template v-for="(fecha, index) in fechas">                        
                            <v-layout 
                            :key='index'
                            v-if="index%2==0"
                            row
                            wrap                                                 
                            > 
                            <v-flex xs12 sm6 md6 >   
                                <v-dialog
                                    ref="dialog"
                                    v-model="fechas[index].modal"
                                    :return-value.sync="fechas[index].date"
                                    persistent
                                    lazy
                                    full-width     
                                    width="290px"                           
                                    >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fechas[index].dateFormatted"
                                        v-bind:label="fechas[index].text"
                                        prepend-icon="event"
                                        readonly
                                        @blur="fechas[index].date = parseDate(fechas[index].dateFormatted);"                                    
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker locale="es-ES" v-model="fechas[index].date" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="fechas[index].modal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog[index].save(fechas[index].date); fechas[index].dateFormatted = formatDate(fechas[index].date); getInvoices();">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>   
                            <v-flex xs12 sm6 md6>   
                                <v-dialog
                                    ref="dialog"
                                    v-model="fechas[index+1].modal"
                                    :return-value.sync="fechas[index+1].date"
                                    persistent
                                    lazy
                                    full-width     
                                    width="290px"                           
                                    >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fechas[index+1].dateFormatted"
                                        v-bind:label="fechas[index+1].text"
                                        prepend-icon="event"
                                        readonly
                                        @blur="fechas[index].date = parseDate(fechas[index].dateFormatted);"                                                                        
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker locale="es-ES" v-model="fechas[index+1].date" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="fechas[index+1].modal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog[index+1].save(fechas[index+1].date); fechas[index+1].dateFormatted = formatDate(fechas[index+1].date); getInvoices();">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>                                                   
                            </v-layout>  
                        </template>                                    
                    </v-container>  
                    <v-expansion-panel>
                    <v-expansion-panel-content
                        v-for="(item,i) in 1"
                        :key="i"
                        >
                        <template v-slot:header>
                            <div>Tipos de documento</div>
                        </template>
                        <v-card>
                            <v-card-text> 
                                <v-container fluid>
                                    <v-layout row wrap class="light--text">
                                        <v-checkbox v-model="selected" :label="docTypes[0].doctype" :value="docTypes[0].value"></v-checkbox>
                                        <v-checkbox v-model="selected" :label="docTypes[1].doctype" :value="docTypes[1].value"></v-checkbox>
                                        <v-checkbox v-model="selected" :label="docTypes[2].doctype" :value="docTypes[2].value"></v-checkbox>
                                        <v-checkbox v-model="selected" :label="docTypes[3].doctype" :value="docTypes[3].value"></v-checkbox>
                                        <v-checkbox v-if="$store.state.usuario.type == 'Comercial'" v-model="selected" :label="docTypes[4].doctype" :value="docTypes[4].value"></v-checkbox>
                                    </v-layout>
                                </v-container>                            
                            </v-card-text>
                        </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--v-flex xs12 lg10 offset-lg1 v-if="$store.state.usuario.type == 'Comercial'">
                        <v-text-field v-model="custFilter" label="Cliente" type="text" required></v-text-field>
                    </v-flex--> 
                    <v-container
                    id="scroll-target"
                    style="max-height: 200px"
                    class="scroll-y"
                    fluid
                    pa-0
                    >                 
                    <v-flex xs12 lg10 offset-lg1 v-if="$store.state.usuario.type == 'Comercial'">
                        <listaClientes/>   
                    </v-flex>
                    </v-container>
                                                
                </v-form>                        
            <!--/v-flex-->
        </v-layout> 
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import listaClientes from '@/components/listaClientes_new.vue'
export default {
    data () {
        return {    
            send347: false,                    
            valid: false,
            docTypes:[{doctype:"Pedido", value:"PEDIDO"},{doctype:"Factura",value:"Factura"},{doctype:"Albarán",value:"Factura Alb."},{doctype:"Abono",value:"Abono"},{doctype:"Tarea",value:"Tarea"}],
            selected:[],
            timeout: null,
            years:[new Date().getFullYear()-1,new Date().getFullYear()-2],
            year: new Date().getFullYear()-1,
            panelIndex: 0
        }
    },
    methods: {
        getCust(){
            let auxthis = this;
            
            this.timeout = setTimeout(function () {
                auxthis.getCustomers();               
                //console.log('test');
            }, 1500);
        },
        mailclick(){
            this.send347 = !this.send347;
        },
        sendclick(){
            this.sendDocument('','347',this.$store.state.usuario.lastEmail,this.year);
            this.send347 = !this.send347;
        }
    },
    components:{
        listaClientes
    },
    computed:{
        customer:{
            get(){
                return this.$store.state.customer;
            }
        }, 
        fechas:{
            get(){
                if (!this.$store.state.appconfig.filterInvoiceDocumentDate){
                    return this.$store.state.fechas.slice(2);
                } else 
                    return this.$store.state.fechas;
            },
            set(value){
                this.$store.commit('setDates',value);                   
            }
        },
        selectedCustIndex:{
            get(){
                return this.$store.state.selectedCustIndex;
            }
        }
    },
    mounted(){
        for(var i = 0; i < this.fechas.length; i++){
            this.fechas[i].dateFormatted = this.formatDate(this.fechas[i].date);
        }
        this.getInvoices(this.selected);
    },
    watch:{
        panelIndex: function(val) {
            var thisAux = this;
            setTimeout(function(){
                thisAux.$vuetify.goTo(0)
            },200);
        },
        customer: function(val, oldVal){
            this.getInvoices(this.selected);
        },
        selected: function(val, oldVal){
            this.getInvoices(val);
        }
    }
}
</script>
<style scoped>
.fullwidth{
    width: 100%;
}
.email347btn{
   float: left; 
}
</style>


